import React from 'react'
import "./Promo.css";
import Galleryimg1 from '../../Images/galleryimg1.png'
import Galleryimg2 from '../../Images/galleryimg2.png'
import Galleryimg3 from '../../Images/galleryimg3.png'
import { Col, Container, Row } from 'react-bootstrap';

const GallerySection = () => {
  return (
    <>
        <div className='gallerymain'>
            {/* <h2>Gallery Content</h2> */}
            <Container fluid>
                <Row className='mobileflip'>
                    <Col md={7} className='gallery1'>
                            <img src={Galleryimg1} className='galborder'/>
                            <img src={Galleryimg2} className='galborder' style={{paddingTop:"20px"}}/>
                    </Col>
                    <Col md={5} className='gallery2'>
                            <h2>Smart, Simple, Sustainable.</h2>
                            <img src={Galleryimg3} className='galborder'/>
                    </Col>
                </Row>
            </Container>
        </div>
    </>
  )
}

export default GallerySection